import React from 'react';
import { TextField } from '@ane/ui-components';
import { getPlaceHolder, dataSourceCreateComponentsName } from '../../utils/DataSourceFormikSettingsUtils';
function validateBlueshiftDependencyPath(value) {
    const invalidCharacters = ['\\', '*', '?', '"', '<', '>', '|'];
    const blueshiftDependencyFileRegexes = [
        /^https:\/\/(?<account>\w+)\.blob\.core\.windows\.net\/(?<container>[\w-]+)\/(?<filepath>.*)$/,
        /^abfss:\/\/(?<container>[\w-]+)@(?<account>\w+)\.dfs.core.windows.net\/(?<filepath>.*)$/,
    ];
    // Check for invalid characters in relative path
    if (!value.includes(':') && invalidCharacters.some((c) => value.includes(c))) {
        return `The dependency file relative path: ${value} shouldn't contain the invalid characters: '\\', '*', '?', '\"', '<', '>', '|'`;
    }
    // Check if path matches one of the Azure blob formats
    const isMatched = blueshiftDependencyFileRegexes.some((regex) => regex.test(value));
    if (value.includes(':') && !isMatched) {
        return `The path of dependency file ${value} doesn't match the format: 'https://<account>.blob.core.windows.net/<container>/<filePath>' or 'abfss://<container>@<account>.dfs.core.windows.net/<filePath>'`;
    }
    return '';
}
export default function DataPathField(props) {
    var _a, _b, _c;
    const { formikProps, index } = props;
    const key = 'DataPath';
    return (React.createElement(TextField, { ariaLabel: `Availability stream ${key}`, isReadOnly: !!props.isReadOnly, required: true, description: getPlaceHolder(dataSourceCreateComponentsName.availabilitystreaminfo, key), value: `${((_a = formikProps === null || formikProps === void 0 ? void 0 : formikProps.values) === null || _a === void 0 ? void 0 : _a.streamList) && ((_b = formikProps === null || formikProps === void 0 ? void 0 : formikProps.values) === null || _b === void 0 ? void 0 : _b.streamList[index][key])}`, errorMessage: validateBlueshiftDependencyPath((_c = formikProps === null || formikProps === void 0 ? void 0 : formikProps.values) === null || _c === void 0 ? void 0 : _c.streamList[index][key]), onChange: (props, newValue) => {
            var _a, _b, _c;
            let streamList = [...(_a = formikProps === null || formikProps === void 0 ? void 0 : formikProps.values) === null || _a === void 0 ? void 0 : _a.streamList];
            if (streamList && streamList[index]) {
                const stream = streamList[index];
                const columnNewValue = (newValue === null || newValue === void 0 ? void 0 : newValue.trim()) || '';
                const validationMessage = columnNewValue ? validateBlueshiftDependencyPath(columnNewValue) : 'Required';
                const updatedStreamList = (_c = (_b = formikProps === null || formikProps === void 0 ? void 0 : formikProps.values) === null || _b === void 0 ? void 0 : _b.streamList) === null || _c === void 0 ? void 0 : _c.map((value, i) => {
                    if (i === index) {
                        return {
                            ...stream,
                            [key]: columnNewValue,
                            required: {
                                ...stream.required,
                                [key]: validationMessage,
                            },
                        };
                    }
                    return value;
                });
                formikProps === null || formikProps === void 0 ? void 0 : formikProps.setFieldValue('streamList', updatedStreamList);
            }
        } }));
}

//# sourceMappingURL=AvailabilityStreamFieldConfig.js.map
